import { render, staticRenderFns } from "./StaticCard.vue?vue&type=template&id=988c41b8&"
import script from "./StaticCard.vue?vue&type=script&lang=js&"
export * from "./StaticCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports